import { create } from 'zustand'

type NewsPaginationState = {
    currentPage: number
    pageSize: number
    setPage: (page: number) => void
    setPageSize: (pageSize: number) => void
    reset: () => void
}

const useNewsPaginationStore = create<NewsPaginationState>((set) => ({
    currentPage: 1,
    pageSize: 10,
    setPage: (page) => set({ currentPage: page }),
    setPageSize: (pageSize) => set({ pageSize }),
    reset: () => set({ currentPage: 1 }),
}))

export default useNewsPaginationStore